// import { API } from '../../api/apiutils';
import { API } from '../middlewares/APIUtils.tsx';

/**
 * Initiate DigiLocker OAuth flow.
 * For a single document, pass document_id.
 * For batch (all docs), omit document_id.
 */
export const initiateDigilockerAPIHelper = async (documentId?: string | number) => {
  try {
    const params: Record<string, any> = {};
    if (documentId) {
      params.document_id = documentId;
    }
    const response = await API.get('/api/digilocker/initiate', { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};

/**
 * Verify a single document with the DigiLocker auth code + code_verifier.
 */
export const verifySingleDocAPIHelper = async (
  documentId: string | number,
  auth_code: string,
  code_verifier: string
) => {
  try {
    const response = await API.post(`/api/verification/${documentId}/verify`, {
      auth_code,
      code_verifier,
    });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};

/**
 * Verify ALL documents with the DigiLocker auth code + code_verifier.
 */
export const verifyAllDocsAPIHelper = async (
  auth_code: string,
  code_verifier: string
) => {
  try {
    const response = await API.post('/api/verification/verify-all', {
      auth_code,
      code_verifier,
    });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response?.data || error.message);
  }
};
